let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3YGga")).then(() => parcelRequire('7iyzo'));